import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=33f9e65c&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=33f9e65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9e65c",
  null
  
)

/* custom blocks */
import block0 from "./EventDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports